import authenticationManager from '@/services/auth/manager';
import userAtom from '@/store/auth/user';
import { Box } from '@mui/material';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { OidcCallbackError } from '@tier4/webauto-auth-frontend-client';
import { useSetAtom } from 'jotai';
import { useCallback, useEffect, useState } from 'react';

const LoginCallbackPage = () => {
  const setUser = useSetAtom(userAtom);
  const navigate = useNavigate();
  const [oidcError, setOidcError] = useState<OidcCallbackError>();

  useEffect(
    () => () => {
      setOidcError(undefined);
    },
    [],
  );

  const signInCallback = useCallback(() => {
    const oidcError = authenticationManager.getOidcError();
    if (oidcError) {
      console.error(oidcError);
      setOidcError(oidcError);
      return;
    }

    (async () => {
      try {
        const response = await authenticationManager.userManager.signInCallback();

        const user = await authenticationManager.userManager.getUser();
        if (!user) {
          console.error('No user data after login callback');
          setOidcError(new OidcCallbackError('unknown', 'No user data after login callback'));
          return;
        }

        setUser(user);
        const redirectUrlStr = response?.url_state ?? '/';
        const url = new URL(redirectUrlStr, window.location.origin);
        const searchParams: Record<string, string> = {};
        url.searchParams.forEach((value, key) => {
          searchParams[key] = value;
        });
        navigate({ to: url.pathname, search: searchParams, replace: true });
      } catch (error) {
        console.error('Login callback error:', error);
        setOidcError(
          error instanceof Error
            ? new OidcCallbackError('request_forbidden', error.message)
            : new OidcCallbackError('unknown', 'unknown error'),
        );
      }
    })();
  }, [setUser, navigate]);

  useEffect(() => {
    signInCallback();
  }, [signInCallback]);

  if (oidcError) {
    // TODO: 後々UIを整える
    return (
      <Box
        sx={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: '600px' }}>
          <h1>Login Callback Error</h1>
          <p>{oidcError.message}</p>
          <Link to="/">Go to Home</Link>
        </Box>
      </Box>
    );
  }

  return <></>;
};

export const Route = createFileRoute('/login/callback')({
  component: LoginCallbackPage,
});
